import { Box, BoxProps } from '@chakra-ui/react';
import Prism from 'prismjs';
import React, { useEffect } from 'react';

import 'prismjs/themes/prism-okaidia.min.css';
import 'prismjs/components/prism-typescript.min';
import 'prismjs/components/prism-javascript.min';

Prism.manual = true;

export interface CodeProps extends BoxProps {
  children: string;
  language: string;
}

export interface LanguageProps extends BoxProps {
  children: string;
}

export const Code: React.FC<CodeProps> = ({
  children,
  language,
  ...boxProps
}) => {
  useEffect(() => {
    Prism.highlightAll();
  }, [children]);

  return (
    <Box {...boxProps}>
      <pre word-break="break-word !important">
        <code
          className={`language-${language}`}
          word-break="break-word !important"
        >
          {children}
        </code>
      </pre>
    </Box>
  );
};

export const Typescript: React.FC<LanguageProps> = ({
  children,
  ...boxProps
}) => (
  <Code language="typescript" {...boxProps}>
    {children}
  </Code>
);
